import * as CreateActions from './create';
import * as EnteredFtrActions from './enteredFtr';
import * as ListActions from './list';
import * as SearchActions from './search';
import * as RecordActions from './record';

const Actions = {
  ...CreateActions,
  ...EnteredFtrActions,
  ...ListActions,
  ...SearchActions,
  ...RecordActions,
};

export default Actions;
